import {calculateInfluencePathIncome} from "../calculateInfluencePathIncome";
import {GUILD_BASIC_INCOME} from "../../../configs/income";
import {FACTIONS} from "../../../constants/factions";
import {FACTION_VENTORY_ADDITIONAL_GUILD_INCOME} from "../../../configs/factions/ventory";
import {isPlayerPolicy} from "../../factions/isPlayerPolicy";
import {POLICIES} from "../../../constants/policies";
import {POLICY_OLIGARCHY_GUILD_INCOME_BONUS} from "../../../configs/policy/oligarchy";
import {isPlayerFaction} from "../../factions/isPlayerFaction";

/**
 * Доход гильдии по слагаемым — для расшифровки дохода игрока (панель статов
 * в шапке); calcGuildIncome — их сумма
 * @returns {{base: number, influence: number, ventory: number, oligarchy: number, total: number}}
 */
export const calcGuildIncomeDetails = (guildHexKey, player, enemyCities, hexes) => {
  const {count} = calculateInfluencePathIncome(guildHexKey, enemyCities, hexes);

  const ventory = isPlayerFaction(player, FACTIONS.VENTORY) ? FACTION_VENTORY_ADDITIONAL_GUILD_INCOME : 0;
  const oligarchy = isPlayerPolicy(player, POLICIES.OLIGARCHY) ? POLICY_OLIGARCHY_GUILD_INCOME_BONUS : 0;

  return {
    base: GUILD_BASIC_INCOME,
    influence: count,
    ventory,
    oligarchy,
    total: GUILD_BASIC_INCOME + count + ventory + oligarchy,
  };
};

export const calcGuildIncome = (guildHexKey, player, enemyCities, hexes) => (
  calcGuildIncomeDetails(guildHexKey, player, enemyCities, hexes).total
);
